module.exports = __webpack_public_path__ + "static/media/Roundabout.dad9c9f4.png";